export default __webpack_public_path__ + "static/happy-cable-4db10b52055b0a854e8c5138351d9003.svg";